import { render, staticRenderFns } from "./nullMenu.vue?vue&type=template&id=41ced1df&scoped=true&"
import script from "./nullMenu.vue?vue&type=script&lang=js&"
export * from "./nullMenu.vue?vue&type=script&lang=js&"
import style0 from "./nullMenu.vue?vue&type=style&index=0&id=41ced1df&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ced1df",
  null
  
)

export default component.exports